<template>
    <InformeCard title="Renovaciones / Nuevas altas">
        <GChart
            type="PieChart"
            :data="chartData"
            :options="chartOptions"
        />
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";

export default {
    props: ['valores'],
    data() {
        return {
            chartOptions: {
                height: 364,
                chartArea:{width:'100%'}
            }
        }
    },
    computed: {
        chartData() {
            var data = null;
            if (this.valores) {
                data = [
                    ['Renovados', 'Nuevos'],
                    ['Renovados', this.valores.renovados],
                    ['Nuevos deportistas', this.valores.nuevos]
                ]
            } else {
                data = null;
            }
            
            return data;
        }
    },
    components: {
        InformeCard,
    }
}
</script>
